export const cur = '£';

export const access = {
  dashboard: "dashboard",
  dashboardDealer: "dealer-dashboard",

  user: "user",
  admin: "admin",
  categories: "categories",
  plan: "plan",
  tier: "tier",
  bank: "bank",
  soldAds: "sold-ads",
  removedExpiredAds: "removed-expired-ads",

  vehicle: "vehicle",
  suspicious: "suspicious",
  finance: "finance",
  makeModel: "makeModel",
  settings: "settings",
  blog: "blog",
  article: "article",

  about: "about",
  contact: "contact",
  dataRequest: "data-request",

  adReport: "adReport"
};


export const accessList = [

  {
    label: "Dashboard",
    value: access.dashboard
  },
  {
    label: "User Management",
    value: access.user
  },
  {
    label: "Admin Management",
    value: access.admin
  },
  {
    label: "Categories Management",
    value: access.categories
  },
  {
    label: "Plan Management",
    value: access.plan
  },
  {
    label: "Bank Management",
    value: access.bank
  },
  {
    label: "Vehicle Management",
    value: access.vehicle
  },
  {
    label: "Suspicious",
    value: access.suspicious
  },
  {
    label: "Finance Management",
    value: access.finance
  },
  {
    label: "Make & Model Management",
    value: access.makeModel
  },
  {
    label: "Settings",
    value: access.settings
  },
  {
    label: "Blog Managemenet",
    value: access.blog
  },
  {
    label: "About",
    value: access.about
  },
  {
    label: "Contact",
    value: access.contact
  },
  {
    label: "Ad Report",
    value: access.adReport
  },
  {
    label: "Removed Expired Ads",
    value: access.removedExpiredAds
  }
];

